import IPadImgV4 from '@components/imageModules/v4/iPadImgV4'
import IPadImgV5 from '@components/imageModules/v5/iPadImgV5'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  screen: {
    img: IGatsbyImageDataObject
    alt: string
  }
  content: {
    headerClasses?: string
    header: string
    text: string
  }
}

function IPadLayoutA(props: Props) {
  const { screen, content: { header, text, headerClasses } } = props

  return (
    <div className='relative pt-[25rem] md:pt-0'>
      <div className='et-grid-basic'>

        <div className='relative col-span-2 col-start-2 md:col-start-7 md:col-span-7'>

          {/* DIV HELPER FOR CENTERING ART */}
          {/* <div className='absolute top-[-390px] left-0 w-[520px] md:left-[-200px] md:top-1/2 md:-translate-y-1/2  md:w-[750px] lg:w-[940px] lg:top-[70%] xl:top-[80%] xl:w-[1040px] '> */}
          <div className='absolute -rotate-[5deg] top-[-390px] left-0 w-[520px] md:top-1/2 md:-translate-y-1/2 md:left-[-700px] md:w-[750px] lg:w-[940px] lg:left-[-950px] lg:top-[87%] xl:w-[1040px] xl:left-[-940px]'>

            <IPadImgV5
              screen={screen}
            />
          </div>

          <div className='md:max-w-[388px] mx-auto md:pl-7 lg:pl-0 lg:max-w-[577px] xl:mr-[-30px] xl:max-w-[616px]'>
            <h2 className={twMerge('mb-6 text-4xl md:text-5xl font-sentinel__SemiBoldItal xl:text-6xl', headerClasses)}>{header}</h2>
            <div
              className='text-lg [&>p]:mb-2 xl:text-xl'
              dangerouslySetInnerHTML={{ __html: text }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default IPadLayoutA
